document.addEventListener("DOMContentLoaded", () => {

  /* ------------------------------------------
     Floating cart visibility
  ------------------------------------------ */

  const product = document.querySelector('.product--large');
  const floatingCart = document.getElementById('floating-cart');

  if (product && floatingCart) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        floatingCart.style.display = entry.isIntersecting ? 'none' : 'block';
      });
    }, { root: null, threshold: 0 });

    observer.observe(product);
  }

  /* ------------------------------------------
     Inject product id into Recharge widget
  ------------------------------------------ */

  (function () {

    const productIdClass = Array.from(document.body.classList)
      .find(c => c.startsWith('product-id-'));

    if (!productIdClass) return;

    function applyProductClass(widget) {
      const root = widget.shadowRoot;
      if (!root) return false;

      const el = root.querySelector('.rc-widget__root');
      if (!el) return false;

      el.classList.add(productIdClass);
      return true;
    }

    function handleWidget(widget) {
      if (applyProductClass(widget)) return;

      const poll = setInterval(() => {
        if (applyProductClass(widget)) clearInterval(poll);
      }, 100);

      setTimeout(() => clearInterval(poll), 5000);
    }

    function processAll() {
      document.querySelectorAll('recharge-subscription-widget')
        .forEach(widget => handleWidget(widget));
    }

    processAll();

    const mo = new MutationObserver(() => processAll());

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

  })();

  /* ------------------------------------------
     Recharge CSS persistent injector
  ------------------------------------------ */

  (function injectRechargeStylesPersistently() {

    const STYLE_ID = 'custom-recharge-style';

    const CSS = `
    .rc-selection__root .rc-purchase-option__sub-container {
        font-size: 15px;
        line-height: 11px;
    }
        .rc-widget__root {
    margin-top: 30px;
}
      .rc-purchase-option {
       padding: 18px 20px;
        }
      .rc-purchase-option:not(:last-child) {
        position: relative;
        border: 2px solid #DAECF0;
        border-radius: 12px;
      }

      .rc-purchase-option:last-child {
        border-radius: 12px;
        border: 2px solid rgba(218, 236, 240, 0.37);
        background: rgba(218, 236, 240, 0.37);
      }

      .rc-purchase-option .rc-price:before {
        content: '';
        display: inline-block;
        margin-right: 10px;
        text-decoration: line-through;
        text-decoration-thickness: 2px;
        color: rgba(0,0,0,.7);
        text-decoration-color: rgba(0,0,0,.7);
      }

      .rc-purchase-option .rc-purchase-option__label {
        display: flex;
        justify-content: space-between;
        padding: 0px;
        cursor: pointer;
        flex-direction: row;
      }

      .rc-purchase-option[rc-selected] {
        border: 2px solid #194BAF !important;
        border-radius: 12px;
      }
      .rc-purchase-option[rc-selected] .rc-purchase-option__selector, .rc-purchase-option[rc-selected] .rc-price{
      color:#000;
      }
      rc-selling-plans {
        display: none !important;
      }
      .rc-purchase-option__selector {
          color: #666;
          font-size: 18px !important;
          line-height:32px !important;
      }
          .rc-price{
          color: #666;
          }
      .rc-purchase-option__prices {
        margin-left: 0;
      }
      @media (max-width: 768px) {
        .rc-purchase-option__selector,
        .rc-price {
          font-size: 15px !important;
        }

        .rc-purchase-option__label {
          padding: 12px 10px;
        }

        .rc-price:before {
          margin-right: 5px;
          font-size: 13px;
        }
      }
    `;

    function apply(widget) {
      if (!widget || !widget.shadowRoot) return;

      if (widget.shadowRoot.getElementById(STYLE_ID)) return;

      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;

      widget.shadowRoot.appendChild(style);
    }

    function processAll() {
      document
        .querySelectorAll('recharge-subscription-widget')
        .forEach(apply);
    }

    processAll();

    const mo = new MutationObserver(() => processAll());

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

  })();
  /* ------------------------------------------
     Ticker
  ------------------------------------------ */

  (function () {

    const SPEED_PX_PER_SEC = 120;
    const MIN_REPEAT = 2;
    const MAX_DT_MS = 100;

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) return;

    function initTicker(ticker) {

      const wrap = ticker.querySelector('.ticker__wrap');
      if (!wrap) return;

      if (!wrap.dataset.originalHtml) {
        wrap.dataset.originalHtml = wrap.innerHTML;
      }

      wrap.innerHTML = wrap.dataset.originalHtml;

      const measurer = wrap.cloneNode(true);
      measurer.style.position = 'absolute';
      measurer.style.visibility = 'hidden';
      measurer.style.left = '-99999px';
      document.body.appendChild(measurer);

      const originalWidth = Math.max(1, Math.ceil(measurer.scrollWidth));
      document.body.removeChild(measurer);

      const containerWidth = Math.max(1, ticker.clientWidth || window.innerWidth);
      const repeatCount = Math.max(
        MIN_REPEAT,
        Math.ceil((containerWidth * 2) / originalWidth)
      );

      let out = '';
      for (let i = 0; i < repeatCount; i++) {
        out += wrap.dataset.originalHtml;
      }

      wrap.innerHTML = out;

      let pos = 0;
      let paused = false;
      let rafId = null;
      let lastTime = performance.now();

      function step(now) {
        let dt = now - lastTime;
        if (dt > MAX_DT_MS) dt = MAX_DT_MS;
        lastTime = now;

        if (!paused) {
          pos += SPEED_PX_PER_SEC * (dt / 1000);
          if (pos >= originalWidth) pos %= originalWidth;
          wrap.style.transform = `translate3d(${-pos}px,0,0)`;
        }

        rafId = requestAnimationFrame(step);
      }

      function start() {
        if (rafId) cancelAnimationFrame(rafId);
        lastTime = performance.now();
        rafId = requestAnimationFrame(step);
      }

      start();
    }

    function initAllTickers() {
      document.querySelectorAll('.ticker').forEach(t => {
        try {
          initTicker(t);
        } catch (e) {
          console.error('Ticker init error', e);
        }
      });
    }

    let resizeTimer = null;

    window.addEventListener(
      'resize',
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initAllTickers, 200);
      },
      { passive: true }
    );

    initAllTickers();

  })();

  /* ------------------------------------------
     Smooth anchor scrolling
  ------------------------------------------ */

  (function () {

    const HEADER_OFFSET = 80;

    const prefersReducedMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.addEventListener('click', function (e) {

      const link = e.target.closest('a[href^="#"]');
      if (!link) return;

      const hash = link.getAttribute('href');
      if (!hash || hash === '#') return;

      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        HEADER_OFFSET;

      window.scrollTo({
        top: targetPosition,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });

      history.pushState(null, '', hash);
    });

  })();
  /* ------------------------------------------
     5 packs info
  ------------------------------------------ */
  (function () {

  function updateFivePackState() {

    const infoBox = document.querySelector('.five-pack-info');
    if (!infoBox) return;

    const checked = document.querySelector('.variant-pill:checked');
    if (!checked) return;

    const isFivePack =
      checked.classList.contains('variant-pill--5-packs') ||
      checked.value.trim().toLowerCase() === '5 packs';

    infoBox.style.display = isFivePack ? 'flex' : 'none';
  }
  document.addEventListener('DOMContentLoaded', updateFivePackState);
  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('variant-pill')) {
      updateFivePackState();
    }
  });
  const mo = new MutationObserver(() => {
    updateFivePackState();
  });

  mo.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

  /* ------------------------------------------
     Checkout Redirect
  ------------------------------------------ */
(function () {
  let isSubmitting = false;
  document.addEventListener(
    'click',
    function (e) {

      const btn = e.target.closest('.add-to-cart-cus');
      if (!btn) return;

      const form = btn.closest('form[action^="/cart/add"]');
      if (!form) return;
      if (btn.closest('.shopify-payment-button')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (isSubmitting) return;
      isSubmitting = true;

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(res => {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(err => {
          console.error('Add-to-cart failed:', err);
          isSubmitting = false;
          form.submit();
        });

    },
    true
  );

})();

});

